import * as url from 'url';

export function parseUpgradeArguments(arg1: string, arg2?: string) {
	let baseUrl: string | undefined;
	let version: string | undefined;
	let directUri: string | undefined;

	if (isUrl(arg1) && arg2 && !isUrl(arg2)) {
		baseUrl = arg1;
		version = arg2;
	} else if (!isUrl(arg1) && arg2 && isUrl(arg2)) {
		baseUrl = arg2;
		version = arg1;
	} else if (isUrl(arg1) && !arg2) {
		directUri = arg1;
	} else if (!isUrl(arg1) && !arg2) {
		version = arg1;
	} else {
		throw new Error(`Invalid arguments. See JSDoc for details`);
	}

	return {
		baseUrl,
		version,
		directUri,
	};
}

function isUrl(arg1: string) {
	return !!url.parse(arg1).hostname;
}
